<template>
	<div class="wrapper">
		图表
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions,
    mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				loading: false,
				seachStatus: false,
				searchData: {},
				// 分页的参数配置
				tablePage: {
					totalResult: 0,
					currentPage: 1,
					pageSize: 10,
					align: "left",
					pageSizes: [10, 20, 50, 100, 500, 1000],
					perfect: true
				},
				tableColumn: [{
						type: 'seq',
						title: '序号',
						width: 50,
						align: "center"
					},
					{
						field: 'name',
						title: '姓名',
						showOverflow: true,
						align: "center",
						minWidth: "200"
					},
					{
						field: 'sex',
						title: '性别',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'age',
						title: '年龄',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'contTel',
						title: '联系方式',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'jobTitle',
						title: '职称',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'workYears',
						title: '从业年限',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'serviceSiteId',
						title: '目前服务企业',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						title: '操作',
						width: 120,
						showOverflow: true,
						slots: {
							default: 'operation'
						},
					}
				],
				tableData: [],
			}
		},
		computed: {
			...mapState([
				"layouts"
			]),
			...mapGetters(['seqId'])
		},
		watch: {
			seqId() {
				// this.getLists()
			}
		},
		created() {
			this.initView()
		},
		methods: {
			...mapActions([
				"getWorkPersonListServe",
				"delWorkPersonServe"
			]),
			initView() {
				// this.getTeamList();
				// this.getCategoryList();
				this.getLists();
			},
			// 是否显示查询功能
			showSearch(bool) {
				this.seachStatus = bool;
			},
			goPage(type, itemData) {
				this.$router.push({
					name: 'AddWorkPerson',
					params: {
						type: type,
						id: type == 'add' ? 'add' : itemData.id
					},
					query: {
						item: type == 'add' ? 'add' : JSON.stringify(itemData)
					}
				})
			},
			getLists() {
				this.loading = true;
				this.getWorkPersonListServe({
					current: this.tablePage.currentPage,
					size: this.tablePage.pageSize,
					param: {
						name: this.searchData.name,
						contTel: this.searchData.contTel,
					}
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.records;
						this.tablePage.totalResult = +res.data.total;
					}
					this.loading = false;
				})
			},
			// 分页功能
			pageChange(item) {
				if (item.type == "size") {
					this.tablePage.currentPage = 1;
				} else {
					this.tablePage.currentPage = item.currentPage;
				}
				this.getLists();
			},
			searchEvent() {
				console.log(this.searchData);
				this.seachStatus = false;
				this.getLists();
			},
			searchReset() {
				this.searchData = {};
				this.getLists();
			},
			remove(id) {
				this.$XModal.confirm("您确定要删除该数据?").then(type => {
					if (type === "confirm") {
						console.log('执行删除操作');
						this.delete(id)
					}
				})
			},
			delete(id) {
				this.delWorkPersonServe({
					id: id
				}).then(res => {
					if (res.code == 200) {
						this.$XModal.message({
							message: '删除成功',
							status: "success"
						});
						this.getLists()
					}
					this.loading = false;
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.wrapper{
	  .datetime{
	    display: flex;
	    align-items: center;
	    span{
	      margin: 0 3px;
	    }
	  }
	}
	.sign i {
		margin-right: 3px;
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}
</style>
